var map = {
	"./adhesive_residue.jpeg": "2d61",
	"./adhesive_residue_overlay.jpeg": "2d06",
	"./base_front.jpeg": "6e1a",
	"./chips.jpeg": "0b20",
	"./chips_overlay.jpeg": "c318",
	"./clouding.jpeg": "c435",
	"./clouding_overlay.jpeg": "8f7d",
	"./scratches.jpeg": "913f",
	"./scratches_overlay.jpeg": "d6d3",
	"./spidercracks.jpeg": "3264",
	"./spidercracks_overlay.jpeg": "8f62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "01cf";